/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Details/Components/DeleteServiceEndpointConfirmationDialog" />
import * as React from "react";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Details/Resources";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { Dialog } from "VSSUI/Dialog";
import { TitleSize } from "VSSUI/Header";
import { ServiceEndpoint } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { DeleteAzureRMServiceEndpointConfirmationDialog } from "DistributedTaskUI/ServiceEndpoints/Details/Components/DeleteAzureRMServiceEndpointConfirmationDialog";
import * as ARMConstants from "DistributedTask/Common/AzureResourcesService/Constants";

export interface IDeleteServiceEndpointConfirmationDialogProps {
    primaryOnClick: () => void;
    onDismiss: () => void;
    onBackNavigation: () => void;
    serviceEndpoint: ServiceEndpoint;
}

export class DeleteServiceEndpointConfirmationDialog extends VssComponent<IDeleteServiceEndpointConfirmationDialogProps, {}> {
    constructor(props: IDeleteServiceEndpointConfirmationDialogProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): React.ReactNode {
        if (this.props.serviceEndpoint.type === ARMConstants.Azurerm && this.props.serviceEndpoint.data["creationMode"] === ARMConstants.SPNCreationMethodAutomatic) {
            return (
                <DeleteAzureRMServiceEndpointConfirmationDialog
                    onBackNavigation={() => { this.props.onBackNavigation(); }}
                    onDismiss={() => { this.props.onDismiss(); }}
                    serviceEndpoint={this.props.serviceEndpoint}
                />
            );
        }

        return (
            <Dialog
                titleProps={{ text: Resources.DeleteDialogTitle, size: TitleSize.Large }}
                onDismiss={() => { this.props.onDismiss(); }}
                footerButtonProps={[
                    {
                        text: Resources.Cancel,
                        onClick: () => {
                            this.props.onDismiss();
                        }
                    },
                    {
                        text: Resources.DeletePrimaryButtonText,
                        primary: true,
                        onClick: () => {
                            this.props.primaryOnClick();
                        }
                    }
                ]}

            >
                <div>
                    {Resources.DeleteDialogMessage}
                </div>
            </Dialog>
        );
    }

}
